import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import Back from "~/components/Icons/arrow-prev2";
import s from "./Breadcrumbs.less";

const Breadcrumbs = ({ items, onClickHandler }) => {
  const history = useHistory();
  const redirectToUserProfilePersonal = useCallback(
    (link) => {
      history.push(`${link}`);
    },
    [history]
  );
  return (
    <div className={s.breadcrumbs}>
      {items.map((item, index) => (
        <div key={`breadcrumbs_${index}`}>
          {index < items.length - 1 ? (
            <a
              href={item.link}
              className={s.link}
              onClick={(e) => {
                e.preventDefault();
                redirectToUserProfilePersonal(item.link);
              }}
            >
              {item.name}
            </a>
          ) : (
            <span>{item.name}</span>
          )}
          <div className={s.icon}>{index < items.length - 1 && <Back />}</div>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;
